@if (label) {
  <label [ngClass]="{'required':required}"
    [attr.for]="fieldId">{{label}}
  </label>
}
<div class="input-component"
  [style.marginTop.px]="marginTop"
  [ngClass]="{'pristine': pristine, 'valid': (validStatus$ | async), 'invalid': (invalidStatus$ | async), 'disabled': disabled}">
  <div class="input-wrapper">
    @if (lineSize === 0) {
      <div class="radio-group"
        [ngClass]="orientation"
        [attr.disabled]="notEnabled ? '' : null">
        @for (so of options; track so) {
          <div class="radio"
            >
            <aa-radio3 [toTranslate]="toTranslate"
              [option]="so"
              name="{{ name }}">
            </aa-radio3>
          </div>
        }
      </div>
    }
    @if (lineSize !== 0) {
      <div class="radio-group"
        [attr.disabled]="notEnabled ? '' : null"
        [style.marginTop.px]="marginTop">
        <table>
          @for (line of lines; track line; let i = $index) {
            <tr>
              @for (so of options.slice(i * lineSize, (i + 1) * lineSize); track so) {
                <td>
                  <aa-radio3 [toTranslate]="toTranslate"
                    [option]="so"
                    name="{{ name }}">
                  </aa-radio3>
                </td>
              }
            </tr>
          }
        </table>
      </div>
    }
    @if ((dirtyStatus$ | async)) {
      <span class="input-validation fa-stack fa-1x"
        >
        <i class="fas fa-stack-2x fa-circle"
        aria-hidden="true"></i>
        <i class="fal fa-stack-1x"
          [ngClass]="{'fa-check': (validStatus$ | async), 'fa-times': (invalidStatus$ | async)}"
        aria-hidden="true"></i>
      </span>
    }
  </div>
  <aa-validation2 [dirty]="dirty"
    [messages]="failures | async">
  </aa-validation2>
</div>
